import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

// جدول مقارنة الفروع (تقرير القطاعات) — فُصل من صفحة التقارير.
export const SegmentTable = ({ segments }) => {
  const { t } = useTranslation();
  if (!segments) return null;

  return (
    <NeuCard className="overflow-x-auto p-4" data-testid="report-segments">
      <p className="label-xs mb-3">{t("acct.report.segments")}</p>
      <table className="w-full min-w-[480px] text-xs">
        <tbody>
          {segments.rows.map((row) => (
            <tr key={row.branch_id} className="border-t border-border/40" data-testid={`segment-row-${row.branch_id}`}>
              <td className="p-2 font-semibold">{row.branch_name}</td>
              <td className="p-2 text-end font-mono" dir="ltr">{row.revenue}</td>
              <td className="p-2 text-end font-mono" dir="ltr">{row.expenses}</td>
              <td className="p-2 text-end font-mono font-bold" dir="ltr">{row.result}</td>
              <td className="p-2 text-end font-mono text-primary" dir="ltr">{row.revenue_share_percent}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </NeuCard>
  );
};
